import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'ui-toggle-button',
    templateUrl: './toggle-button.component.html',
    styleUrls: ['./toggle-button.component.scss'],
    standalone: false
})
export class ToggleButtonComponent {
  @Input('p-is-selected') isSelected: boolean = false;
  @Output('p-click') onClick = new EventEmitter<MouseEvent>();

  emitClick(event: MouseEvent) {
    this.onClick.emit(event);
  }
}
